export default "__VITE_ASSET__K_5U8cDf__"